import './ActiveApplications.css'
import { useState } from 'react'
import { Collapse, Button, Modal, ModalBody } from 'reactstrap'
import DetailsArrow from '../../utils/DetailsArrow'
import { useNavigate } from 'react-router-dom'
import Lottie from 'react-lottie'
import * as animationData from '../../assets/134878-warning-status.json'
import * as animationData2 from '../../assets/76705-error-animation.json'
import Conditions from './Conditions'
import { useDispatch } from 'react-redux'
import { setFileNumber } from '../../store/dosya_sayisi'
import { setAgeNumber } from '../../store/yas_aralik/index'
import { setPageState } from '../../store/page_state/index'
import TubitakWarningModal from './TUBITAKDergiForm/Modals/TubitakWarningModal'
import { IconInfoCircleFilled, IconCalendarWeek, IconCircleCheckFilled } from '@tabler/icons-react'

const ActiveApplications = ({ adi, son_basvuru_tarihi, basvuru_sartlari_title, basvuruId, basvuru_fotografi, basvuru_fotograflari, basvuru_aciklamasi, belge_aciklama, ucret, ownerItem, basvuru_sartlari_aciklama, basvuru_turu, belge_sayisi, yas_siniri, ikametgah_karatay_mi, basvuru_durum, custom_inputs, route, age, user }) => {
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)
  const [modal, setModal] = useState(false)
  const [ownerModal, setOwnerModal] = useState(false)
  const [warningModalOpen, setWarningModalOpen] = useState({
    state: '',
    active: false,
    message: '',
  })

  const dispatch = useDispatch()

  console.log('basvuruId:', basvuruId)

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: age < Number(yas_siniri) ? animationData : animationData2,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  const toggleApp = () => setIsOpen(!isOpen)

  const toggleSartlar = (e) => {
    e.stopPropagation()
    setModal(!modal)
  }

  const toggleOwnerModal = (e) => {
    e.stopPropagation()
    setOwnerModal(!ownerModal)
  }

  const ownerItemStatus = ownerItem?.find((item) => item?.basvuru.item.id === basvuruId)?.basvuru.durum.id

  return (
    <>
      <div
        className='applications'
        onClick={toggleApp}
        style={{
          transition: 'border-color 0.8s ease',
          boxShadow: 'none',
          borderColor: '#efefe7',
        }}
      >
        <div className='applications-text'>
          <div>
            <p style={{ margin: 0, fontWeight: 'normal' }}>{adi}</p>
          </div>
          <span
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <h6
              style={{
                marginRight: '0.5rem',
                marginTop: '0.5rem',
                fontSize: '10px',
                color: 'grey',
              }}
            >
              {isOpen ? 'Gizle' : 'Detay'}
            </h6>
            <DetailsArrow visible={isOpen} />
          </span>
        </div>
        <Collapse isOpen={isOpen}>
          <hr style={{ margin: '0.5rem 0', zIndex: 0 }} />
          <div className='sartlar'>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <IconCalendarWeek size={28} color='#285843' />
              <div className='date'>
                <p
                  style={{
                    color: '#285843',
                  }}
                >
                  Son Başvuru Tarihi
                </p>
                <p style={{ fontWeight: 400 }}>{son_basvuru_tarihi}</p>
              </div>
            </div>

            <div
              className='buttons'
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {basvuru_sartlari_title && basvuru_sartlari_aciklama ? (
                <Button
                  size='sm'
                  onClick={toggleSartlar}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'orange',
                    color: '#fff',
                    border: 'none',
                    marginRight: '0.1rem',
                  }}
                >
                  <IconInfoCircleFilled size={20} style={{ marginRight: '0.1rem' }} color='#fff' />
                  Şartlar
                </Button>
              ) : null}
              {basvuru_durum && (
                <Button
                  onClick={(e) => {
                    console.log('ownerItem:', ownerItem)
                    // BISIKLET: veli çocuğu adına başvurabildiği için giriş yapan kişinin yaşına bakılmaz;
                    // yaş kontrolü sporcuya göre formda/kategoride yapılır.
                    // ATLETIZM: yaş kademesi cinsiyete göre değiştiğinden uygunluk kontrolü preview/backend tarafında yapılır.
                    if (route !== 'BISIKLET' && route !== 'ATLETIZM' && !(Number(age) >= yas_siniri.split('-')[0] && Number(age) <= yas_siniri.split('-')[1])) {
                      setWarningModalOpen({
                        active: true,
                        state: 'age',
                        message: 'Başvuru için yaşınız uygun değil.',
                      })
                      return false
                    }

                    if (route === 'TUBITAK') {
                      navigate('tubitak-form', {
                        state: {
                          basvuru_id: basvuruId,
                          basvuru_sartlari_title: basvuru_sartlari_title,
                          basvuru_sartlari_aciklama: basvuru_sartlari_aciklama,
                          basvuru_fotografi: basvuru_fotografi,
                          basvuru_aciklamasi: basvuru_aciklamasi,
                          age: age,
                        },
                      })
                    } else if (route === 'TESIS') {
                      // navigate('tesisler-form', {
                      //   state: {
                      //     basvuru_id: basvuruId,
                      //     basvuru_sartlari_title: basvuru_sartlari_title,
                      //     basvuru_sartlari_aciklama: basvuru_sartlari_aciklama,
                      //     basvuru_fotografi: basvuru_fotografi,
                      //     basvuru_aciklamasi: basvuru_aciklamasi,
                      //   },
                      // })
                      navigate('tesisler-form', {
                        state: {
                          basvuru_id: basvuruId,
                          basvuru_sartlari_title: basvuru_sartlari_title,
                          basvuru_sartlari_aciklama: basvuru_sartlari_aciklama,
                          basvuru_fotografi: basvuru_fotografi,
                          basvuru_aciklamasi: basvuru_aciklamasi,
                          age: age,
                          yas_siniri: yas_siniri,
                        },
                      })
                    } else if (route === 'ESPOR') {
                      navigate('e-spor-form', {
                        state: {
                          basvuru_id: basvuruId,
                          basvuru_sartlari_title: basvuru_sartlari_title,
                          basvuru_sartlari_aciklama: basvuru_sartlari_aciklama,
                          basvuru_fotografi: basvuru_fotografi,
                          basvuru_aciklamasi: basvuru_aciklamasi,
                        },
                      })
                    } else if (route === 'THEATRE') {
                      navigate('theatre-ticket', {
                        state: {
                          basvuru_id: basvuruId,
                          basvuru_sartlari_title: basvuru_sartlari_title,
                          basvuru_sartlari_aciklama: basvuru_sartlari_aciklama,
                          basvuru_fotografi: basvuru_fotografi,
                          basvuru_fotograflari: basvuru_fotograflari,
                          basvuru_aciklamasi: basvuru_aciklamasi,
                          basvuru_turu: basvuru_turu,
                          age: age,
                        },
                      })
                    } else if (route === 'HOBBYGARDEN') {
                      const my_state = {
                        state: {
                          basvuru_id: basvuruId,
                          basvuru_sartlari_title: basvuru_sartlari_title,
                          basvuru_sartlari_aciklama: basvuru_sartlari_aciklama,
                          basvuru_fotografi: basvuru_fotografi,
                          basvuru_aciklamasi: basvuru_aciklamasi,
                          ucret: ucret,
                        },
                      }
                      dispatch(setPageState(my_state.state))
                      navigate('hobiHome', my_state)
                    } else if (route === 'TABIAT') {
                      e.stopPropagation()
                      navigate('tabiat-basvuru', {
                        state: {
                          basvuruId: basvuruId,
                          basvuru_sartlari_title: basvuru_sartlari_title,
                          basvuru_sartlari_aciklama: basvuru_sartlari_aciklama,
                          basvuru_fotografi: basvuru_fotografi,
                          basvuru_aciklamasi: basvuru_aciklamasi,
                        },
                      })
                    } else if (route === 'BISIKLET') {
                      // Veli birden fazla çocuk için başvurabilir; yaş ve mükerrer kontrolü
                      // sporcuya göre (kategori + TC) form ve backend'de yapılır.
                      e.stopPropagation()
                      navigate('bisiklet-yarisi', {
                        state: {
                          basvuruId: basvuruId,
                          basvuru_sartlari_title: basvuru_sartlari_title,
                          basvuru_sartlari_aciklama: basvuru_sartlari_aciklama,
                          basvuru_fotografi: basvuru_fotografi,
                          basvuru_aciklamasi: basvuru_aciklamasi,
                          yas_siniri: yas_siniri,
                        },
                      })
                    } else if (route === 'ATLETIZM') {
                      // Başvuru bireyseldir; kategori ve yaş uygunluğu profil bilgilerinden sunucuda belirlenir.
                      e.stopPropagation()
                      navigate('atletizm-yarisi', {
                        state: {
                          basvuruId: basvuruId,
                          basvuru_sartlari_title: basvuru_sartlari_title,
                          basvuru_sartlari_aciklama: basvuru_sartlari_aciklama,
                          basvuru_fotografi: basvuru_fotografi,
                          basvuru_aciklamasi: basvuru_aciklamasi,
                          yas_siniri: yas_siniri,
                        },
                      })
                    } else if (route === 'EVLILIK') {
                      const checkYasSiniri = Number(age) >= yas_siniri.split('-')[0] && Number(age) <= yas_siniri.split('-')[1]
                      if ((ownerItemStatus && ownerItemStatus === 4 && checkYasSiniri) || checkYasSiniri) {
                        e.stopPropagation()

                        // belge_sayisi
                        dispatch(setFileNumber(Number(belge_sayisi)))
                        dispatch(setAgeNumber(Number(yas_siniri)))
                        navigate('evlilik', {
                          state: {
                            basvuruId: basvuruId,
                            basvuru_sartlari_title: basvuru_sartlari_title,
                            basvuru_sartlari_aciklama: basvuru_sartlari_aciklama,
                            basvuru_fotografi: basvuru_fotografi,
                            basvuru_aciklamasi: basvuru_aciklamasi,
                            belge_aciklama: belge_aciklama,
                            ucret: ucret,
                            belge_sayisi: belge_sayisi,
                            yas_siniri: yas_siniri,
                            ikametgah_karatay_mi: ikametgah_karatay_mi,
                            custom_inputs: custom_inputs,
                          },
                        })
                      } else {
                        toggleOwnerModal(e)
                      }
                    } else {
                      const checkYasSiniri = Number(age) >= yas_siniri.split('-')[0] && Number(age) <= yas_siniri.split('-')[1]
                      if ((ownerItemStatus && ownerItemStatus === 4 && checkYasSiniri) || checkYasSiniri) {
                        e.stopPropagation()

                        // belge_sayisi
                        dispatch(setFileNumber(Number(belge_sayisi)))
                        dispatch(setAgeNumber(Number(yas_siniri)))
                        navigate('basvur', {
                          state: {
                            basvuruId: basvuruId,
                            basvuru_sartlari_title: basvuru_sartlari_title,
                            basvuru_sartlari_aciklama: basvuru_sartlari_aciklama,
                            basvuru_fotografi: basvuru_fotografi,
                            basvuru_aciklamasi: basvuru_aciklamasi,
                            belge_aciklama: belge_aciklama,
                            ucret: ucret,
                            belge_sayisi: belge_sayisi,
                            yas_siniri: yas_siniri,
                            ikametgah_karatay_mi: ikametgah_karatay_mi,
                            custom_inputs: custom_inputs,
                          },
                        })
                      } else {
                        toggleOwnerModal(e)
                      }
                    }
                  }}
                  size={'sm'}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#285843',
                    color: '#fff',
                    border: 'none',
                  }}
                >
                  <IconCircleCheckFilled size={20} style={{ marginRight: '0.1rem' }} color='#fff' />
                  Başvur
                </Button>
              )}
            </div>
          </div>
        </Collapse>
      </div>

      <Conditions toggle={toggleSartlar} modal={modal} basvuruSartlariTitle={basvuru_sartlari_title} basvuru_sartlari_aciklama={basvuru_sartlari_aciklama} />
      <Modal isOpen={ownerModal} toggle={toggleOwnerModal} scrollable={true} centered={true} size={'32'}>
        <div style={{ with: '100%', marginTop: '0.5rem' }}>
          <Lottie options={defaultOptions} height={75} width={75} />
        </div>
        <ModalBody
          style={{
            color: '#285843',
            fontSize: '1rem',
            textAlign: 'center',
            marginTop: -15,
            lineHeight: 1.25,
          }}
        >
          {age > Number(yas_siniri) ? 'Başvuru yapabilmeniz için ' + yas_siniri + ' yaşından büyük olmamanız gerekmektedir.' : 'Daha önce başvuru yaptığınız için tekrar başvuramazsınız.'}
        </ModalBody>
      </Modal>
      <TubitakWarningModal show={warningModalOpen.active} onHide={() => setWarningModalOpen({ state: '', active: false })} state={warningModalOpen.state} message={warningModalOpen.message} />
    </>
  )
}

export default ActiveApplications
